export default {
  computed: {
    environment () {
      if (process.env.API_BASE_URL === 'http://localhost:5000') {
        return 'development'
      } else if (process.env.API_BASE_URL === 'http://stagingagcmn-env.pzcifmixie.us-east-2.elasticbeanstalk.com') {
        return 'staging'
      } else if (process.env.API_BASE_URL === 'https://admin.agcmn.org') {
        return 'live'
      } else {
        return 'development'
      }
    },
    quickbooksBaseUrl () {
      if (this.environment === 'development') {
        return 'https://c50.sandbox.qbo.intuit.com/app/'
      } else if (this.environment === 'staging') {
        return 'https://c50.sandbox.qbo.intuit.com/app/'
      } else if (this.environment === 'live') {
        return 'https://c11.qbo.intuit.com/app/'
      } else {
        return ''
      }
    },
    merchantCenterUrl () {
      if (this.environment === 'development') {
        // return 'https://merchantcenter.ptcfe.intuit.com/qbms'
        // return 'https://merchantcenter.intuit.com/msc/portal/'
        return 'https://merchantcenter.intuit.com/qbms'
      } else if (this.environment === 'staging') {
        return 'https://merchantcenter.intuit.com/qbms'
      } else if (this.environment === 'live') {
        return 'https://merchantcenter.intuit.com/qbms'
      } else {
        return 'https://merchantcenter.intuit.com/qbms'
      }
    },
    merchantCenterTransactionUrl () {
      if (this.environment === 'development') {
        // return 'https://merchantcenter.ptcfe.intuit.com/portal/authsec/portal/qbms/Search+and+reporting/TransactionDetail?transactionId='
        return 'https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Search+and+reporting/TransactionDetail?transactionId='
      } else if (this.environment === 'staging') {
        return 'https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Search+and+reporting/TransactionDetail?transactionId='
      } else if (this.environment === 'live') {
        return 'https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Search+and+reporting/TransactionDetail?transactionId='
      } else {
        return ''
      }
    },
    quickbooksConnectUrl () {
      return process.env.API_BASE_URL + '/api/quickbooksauth/connect'
    }
  }
}
